import React from 'react'
import moment from 'moment'
import styled from 'styled-components'

import StateDispatch from './contextInfo'

import {
  Scatter,
  ScatterChart,
  XAxis,
  YAxis,
  Tooltip
} from 'recharts'


const CardRevenueWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
`

const Title = styled.h1`
  font-size: 1.2em;
  font-weight: 400; 
  line-height: 100%;
  letter-spacing: 0.05em;
  padding-top: 1.2rem;
  margin-bottom: 1rem;
  color: #373D3F;
`
const ScatterChartWrapper = styled.div`
  flex-grow: 1;

  display: flex;
  align-items: center;
`
function convert(time) {
  return moment.unix(time).format('MMM D YYYY')
} 

export default function CardSubscribers ({ chartData }) {
  const info = React.useContext(StateDispatch)

  let myCount = 1;
  const mapSubscribers = []

  for (let i = 0; i < info.length; i++) {
    let curClient = info[i];
    let { clientfrom, name} = curClient

    mapSubscribers.push({ time: `${clientfrom}`, name: name })
  }

  mapSubscribers.sort((a,b) => {
    if (a.time < b.time) return -1
    else if (a.time > b.time) return 1
    else return 0
  })

  for (let i = 0; i < mapSubscribers.length; i++) {
    let curClient = mapSubscribers[i];
    curClient.value = myCount++
  }

  return (
    <CardRevenueWrapper>
      <Title>Subscribers</Title>
      <ScatterChartWrapper>
        <ScatterChart
          width={270}
          height={260}
        >
          <XAxis
            dataKey = 'time'
            domain = {['auto', 'auto']}
            name = 'Time'
            tickFormatter = {(unixTime) => moment.unix(unixTime).format('MMM YY')}
            type = 'number'
          />
          <YAxis dataKey="value" name="Value" hide={true} />
          <Tooltip 
            formatter={(value, name, props) => {
              if (name === 'Time') {
                return [convert(value), 'Date:']
              } else {
                return [value, 'Total:']
              }
            }} 
            cursor={{ strokeDasharray: '3 3' }} 
            separator={' '}
          />
          <Scatter 
            line = {{ stroke: '#eee' }}
            lineJointType = 'monotoneX'
            lineType = 'joint'
            name = 'Values'
            data={mapSubscribers} 
            fill="#4285F4"
            shape={item => {
              const itemWidth = item.width/24 ;
              const itemHeight = item.height/7 ;
              return (
                <rect
                  stroke="#4285F4"
                  strokeWidth={3}
                  x={item.cx - (itemWidth / 2)}
                  y={item.cy - (itemHeight / 2)}
                  width={itemWidth}
                  height={itemHeight}
                />
              );
            }}
          />
        </ScatterChart>
      </ScatterChartWrapper>
    </CardRevenueWrapper>
    );

}

